<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('taskInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="taskForm" :rules="rules" ref="taskForm" label-width="200px">
					  <el-card >
              <el-row>
                <el-col style="text-align: right;" :xs="24" :md="24">
                  <el-button v-has="{class:'taskSub'}" v-if="flagStatus=='0'" size="mini" type="primary" @click="addSubtask">{{$t('addSubtask')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectName1')" >
                    <el-select v-model="taskForm.projectId" disabled >
                      <el-option v-for="item in ProjectList" :key="item.projectNumber" :label="item.projectName" :value="item.projectNumber"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskType1')" >
                    <el-select v-model="taskForm.taskType" disabled >
											<el-option v-for="item in TaskTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskName1')" >
										<el-input v-model="taskForm.taskName" disabled />
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceBom1')" >
                    <el-select v-model="taskForm.serviceBom" disabled >
                      <el-option v-for="item in ServiceBomList" :key="item.serviceBom" :label="item.serviceBom" :value="item.serviceBom"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('bomDescription1')">
                    <el-input v-model="taskForm.bomDescription" disabled />
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskOwner1')" >
                    <el-select v-model="taskForm.taskOwner" disabled >
                      <el-option v-for="item in TaskOwnerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskStatus1')" >
                    <el-select v-model="taskForm.taskStatus" disabled>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceContent1')" >
                    <el-select v-model="taskForm.serviceContent" disabled >
											<el-option v-for="item in ServiceContentList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
                    <el-input v-model="taskForm.serviceContent" disabled />
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceQuantity1')" >
										<el-input v-model="taskForm.serviceQuantity" disabled />
									</el-form-item>
								</el-col>
              </el-row> -->
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('financialAttributes1')">
                    <el-select v-model="taskForm.financialAttributes" disabled>
											<el-option v-for="item in FinancialAttributesList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationMethod1')" >
                    <el-select v-model="taskForm.revenueConfirmationMethod" disabled>
											<el-option v-for="item in RevenueConfirmationMethodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskSubcontract1')" >
                    <el-select v-model="taskForm.subcontract" disabled>
											<el-option v-for="item in SubcontractList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('serviceDuration1')" >
										<el-input v-model="taskForm.serviceDuration" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('hardwareProductLine1')" >
										<el-select v-model="taskForm.hardwareProductLine" disabled>
											<el-option v-for="item in HardwareProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceProductLine1')">
                    <el-select v-model="taskForm.serviceProductLine" disabled>
											<el-option v-for="item in ServiceProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row> -->
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskStartDate1')" >
										<el-date-picker v-model="taskForm.taskStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskEndDate1')">
										<el-date-picker v-model="taskForm.taskEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryArea1')" >
                    <el-input v-model="taskForm.deliveryArea" disabled />
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryFinishDate1')" >
                    <el-date-picker v-model="taskForm.deliveryFinishDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
									</el-form-item>
								</el-col>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryLabourHour1')" >
                    <el-input v-model="taskForm.deliveryLabourHour" disabled />
									</el-form-item>
								</el-col> -->
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationAmount1')" >
										<el-input v-model="taskForm.revenueConfirmationAmount" disabled />
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationStatus1')">
										<el-input v-model="taskForm.revenueConfirmationStatus" disabled />
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subcontractNo1')" >
                    <el-input v-model="taskForm.subcontractNo" disabled />
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskSubcontractor1')" >
                    <el-input v-model="taskForm.subcontractor" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskAmountWithTax1')" >
                    <el-input v-model="taskForm.amountWithTax" disabled />
									</el-form-item>
								</el-col>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskCompletion1')" >
                    <el-select v-model="taskForm.taskCompletion" disabled>
											<el-option v-for="item in TaskCompletionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col> -->
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('planLabourHour1')" >
                    <el-input v-model="taskForm.plannedLabourHour" disabled />
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveredLabourHour1')" >
                    <el-input v-model="taskForm.deliveredLabourHour" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('taskReport1')"  >
                    <!-- <a style="cursor:pointer;color:blue;" @click="handleOpenUrl(fileAliasName,fileName)">{{fileName}}</a> -->
                    <el-upload action="" :file-list="fileList" :on-preview="handlePreview" disabled>
                      <span>{{'Click the file name to download'}}</span>
                    </el-upload>
                  </el-form-item>
								</el-col>
							</el-row>
              <el-row v-if="this.$route.params.showRun=='Y'">
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
    <el-tab-pane name="second" :label="$t('inventory')">
      <el-row>
				<el-col :xs="24">
            <el-table :data="inventoryList" border>
              <el-table-column prop="productBom" :label="$t('productBom')" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="productName" :label="$t('productName')" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="productDesc" :label="$t('productDesc')"  align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="serviceBom" :label="$t('serviceBom')" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changeInventoryPageSize" @current-change="changeInventoryPage" :current-page="currentInventoryPage" :page-sizes="[5,10,20,50]"
                :page-size="pageInventorySize" layout="total, prev, pager, next, sizes, jumper" :total="totalInventoryCount">
              </el-pagination>
            </div>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getProjectList();
          this.getTaskData();
          this.getTaskTypeList();
        },
        data () {
          return {
            rangeNumber: 10,
            taskForm: {
              projectId:null,
              taskName:null,
              taskOwner:null,
              taskStatus:null,
              taskType:null,
              serviceBom:null,
              bomDescription:null,
              financialAttributes:null,
              subcontract:null,
              subcontractor:null,
              revenueConfirmationMethod:null,
              hardwareProductLine:null,
              serviceProductLine:null,
              serviceDuration:null,
              taskStartDate:null,
              taskEndDate:null,
              deliveryArea:null,
              deliveryLabourHour:null,
              revenueConfirmationAmount:null,
              revenueConfirmationStatus:null,
              amountWithTax:null,
              deliveryFinishDate:null,
              remasubcontractNork:null,
              taskCompletion:null,
              taskReport:null,
              planLabourHour:null,
              deliveredLabourHour:null,
            },
            reportArr:[],
            fileList:[],
            flagStatus:1,
            fileOriginalName:'',
            fileRealName:'',
            TaskOwnerList:[],
            ProjectList:[],
            PJList:[],
            ServiceBomList:[],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            TaskTypeList:[],
            FinancialAttributesList:[
              { value: 'Warranty',label: 'Warranty'},
              { value: 'ServiceCost',label: 'Service Cost'},
              { value: 'ExchangeFee',label: 'Market Support Expense'},
              { value: 'PlatformFee',label: 'Platform Expense'},
              { value: 'MarketingFee',label: 'Service Marketing Expense'},
            ],
            RevenueConfirmationMethodList:[
              { value: 'PS-CTC',label: 'PS-CTC'},
              { value: 'PS-COM',label: 'PS-COM'},
              { value: 'PS-PER',label: 'PS-PER'},
              { value: 'PS-NRA',label: 'PS-NRA'},
            ],
            SubcontractList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            TaskCompletionList:[
              { value: 'uncomplete',label: '未完成'},
              { value: 'completed',label: '完成'},
            ],
            rules: {
              projectId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              taskStatus: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskOwner: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskType: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              serviceContent: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              bomDescription: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              financialAttributes: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              taskEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              deliveryArea: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              deliveryFinishDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
            },
            inventoryList:[],
            currentInventoryPage: 1,
            totalInventoryCount: 0,
            pageInventorySize: 5,
          } 
        },
        methods: {
          getTaskTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'TaskType',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res =>{
                this.TaskTypeList = res.data;
              }
            )
          },
          getProjectList(){
            let url =`${this.$store.state.islhurl}project/getSelectProjectToDetail`;
            this._get(url).then(
              res => {   
                this.PJList = res.data;
              }
            )
          },
          //回显数据
          getTaskData(){
            let pm = {};
            let taskId = this.$route.params.taskNumber;
            if(taskId != undefined && taskId != null && taskId != ''){
              pm = {
                taskNumber: taskId,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }else{
              pm = {
                id: this.$route.params.id,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }
            // console.log(pm)
            let url = `${this.$store.state.islhurl}task/getInfo`
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  this.filterUserCode(res.task.taskOwner);
                }, 1500);
                setTimeout(() => {
                  this.filterProjectCode(res.task.projectId);
                }, 800);
                //再进行赋值
                this.taskForm = res.task;
                if(res.task.serviceBom){
                  this.getInventoryList()
                }
                this.flagStatus = res.task.flagStatus;
                //若有附件，显示附件名称
                if(res.task.taskReport != null && res.task.taskReport != 0){
                  let reportAy = res.task.taskReport.split(",");
                  reportAy.forEach(item => {
                    let params = {
                      id: item,
                      islhToken : sessionStorage.getItem('islhtoken'),
                    }
                    let url =`${this.$store.state.islhurl}attachment/getInfo`;
                    this._post(url, params).then(
                      res =>{
                        this.fileList.push({name: res.attachment.fileName, url: res.attachment.fileAliasName});
                        this.reportArr.push({aid: res.attachment.id, fileurl: res.attachment.fileAliasName});
                      }
                    )
                  });
                }
              }
            )
          },
          //展示产品清单列表
          getInventoryList(){
            let num = this.taskForm.serviceBom
            let pm = {}
            let url = `${this.$store.state.islhurl}getProductTypeByServiceBom/${this.pageInventorySize}/${this.currentInventoryPage}?serviceBom=${num}`
            this._post(url,pm).then(
              res =>{
                this.inventoryList = res.data
                this.totalInventoryCount = res.totalNums
              }
            )
          },
          changeInventoryPage (val) {
            this.currentInventoryPage = val;
            this.getInventoryList();
          },
          changeInventoryPageSize (val) {
            this.pageInventorySize = val;
            this.getInventoryList();
          },
          handlePreview(file){
            let url =`${this.$store.state.islhurl}download?fileAliasName=${file.url}&fileName=${file.name}`
            window.open(url);
          },
          addSubtask() {
            let pm = {
              taskNumber: this.taskForm.taskNumber,
            }
            this.$router.push({name:'subtask_add',params:pm})
          },
          returnList(){
            let pm = this.$route.params;
            this.$router.push({name:'task',params:pm});
          },
          filterUserCode(filterVal){
            if (filterVal) {
              let url =`${this.$store.state.islhurl}user/batch-get`;
              let obj = {
                empCodeList: [filterVal]
              }
              this._post(url, obj).then(
                res => {  
                  if(res.code === 200 && res.data) {
                    this.TaskOwnerList = res.data
                  }
                }
              )
            }
          },
          filterProjectCode(filterVal){
            if(filterVal){
              let filterArr = this.PJList.filter(item => {
                return item.projectNumber.toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
              })
              this.ProjectList = filterArr;
            }else{
              this.ProjectList = this.PJList;
            }
          },
        },
    }
</script>


// WEBPACK FOOTER //
// src/view/task/taskDetail.vue